const root = "/rate-cards";

export const rateCardRoutes = {
  root: root,
  detail: (rateCardCode: string) => ({
    root: `${root}/${rateCardCode}`,
  }),
};
